(() => {
  function init(scope) {
    const root = scope.querySelector('#sy-review');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const button = root.querySelector('.sy-menu');
    const nav = root.querySelector('.sy-mobile-nav');
    if (!button || !nav) return;
    const close = () => { nav.hidden = true; button.setAttribute('aria-expanded', 'false'); button.textContent = 'Menu'; };
    button.addEventListener('click', () => { const open = button.getAttribute('aria-expanded') !== 'true'; nav.hidden = !open; button.setAttribute('aria-expanded', String(open)); button.textContent = open ? 'Close' : 'Menu'; });
    nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
    root.addEventListener('keydown', event => { if (event.key === 'Escape' && !nav.hidden) { close(); button.focus(); } });
  }
  init(document);
  if (!window.syRedesignEditorBound) {
    document.addEventListener('shopify:section:load', event => init(event.target));
    window.syRedesignEditorBound = true;
  }
})();
